import React from 'react';
import { Tag, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import type { OrderDocumentCompleteness } from '../../../types/orderDocumentCompleteness';
import './OrderDocumentCompletenessTags.css';
import { completenessStateColor, completenessSummary } from '../orderDocumentCompletenessPresentation';

/** Compact list presentation of the same server-owned checks as the order card. */
export default function OrderDocumentCompletenessTags({ value, status }: { value?: OrderDocumentCompleteness; status?: string }) {
  const { t } = useTranslation('orders');
  const pending = value?.checks.filter(check => check.state !== 'COMPLETE');
  const summary = completenessSummary(value, status);
  return <div className="order-completeness-tags" data-testid="order-completeness-tags">
    {pending?.length ? pending.map(check => {
      const state = check.code === 'TRANSPORT_INVOICE' && check.state === 'PARTIAL' ? 'PARTIAL_TRANSPORT_INVOICE' : check.state;
      const label = t(`orders:documentCompleteness.shortCodes.${check.code}`);
      const detail = `${t(`orders:documentCompleteness.codes.${check.code}`)}: ${t(`orders:documentCompleteness.states.${state}`)}`;
      const count = check.missingCount !== undefined
        ? t('orders:documentCompleteness.trucks', { count: check.missingCount, total: check.totalCount }) : '';
      return <Tooltip key={check.code} title={[detail, count].filter(Boolean).join(' · ')}>
        <Tag color={completenessStateColor[check.state]}>
          {label} · {t(`orders:documentCompleteness.shortStates.${check.state}`)}
        </Tag>
      </Tooltip>;
    }) : <Tooltip title={t(`orders:documentCompleteness.${summary === 'unknown' ? 'states.UNKNOWN' : summary}`)}>
      <Tag color={summary === 'complete' ? 'green' : 'default'}>{t(`orders:documentCompleteness.summary.${summary}`)}</Tag>
    </Tooltip>}
  </div>;
}
